import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import ContentLoader from 'react-content-loader';
import {
  spotLoader,
  solicitacaoChamadaLoader,
  solicitacaoPromoLoader,
  chamadaEditLoader,
} from './GenericLoaderData';

export interface LoaderData {
  type: 'text' | 'random_text' | 'circle' | 'flag' | 'tdflag';
  x: string;
  headerX: string;
  width?: number;
  radius?: number;
  headerWidth: number;
}
const Header = (props: { data: LoaderData[] }) => {
  const themeContext = useContext(ThemeContext);
  return (
    <ContentLoader
      backgroundColor={themeContext?.loadingTableColor}
      foregroundColor={themeContext?.loadingTableColorLight}
      backgroundOpacity={1}
      foregroundOpacity={0.5}
      width="100%"
      height="40"
      speed={1.2}
      preserveAspectRatio="xMinYMin"
    >
      {props.data.map((d, i) => (
        <rect
          x={d.headerX}
          y="0"
          rx="5"
          ry="5"
          width={d.headerWidth}
          height="20"
          key={`header_${i}`}
        />
      ))}
    </ContentLoader>
  );
};

const Table = (props: { data: LoaderData[] }) => {
  const themeContext = useContext(ThemeContext);
  return (
    <ContentLoader
      backgroundColor={themeContext?.loadingTableColor}
      foregroundColor={themeContext?.loadingTableColorLight}
      backgroundOpacity={1}
      foregroundOpacity={0.5}
      width="100%"
      height="95%"
      speed={1.2}
      preserveAspectRatio="xMinYMin"
    >
      {Array(10)
        .fill('')
        .map((e, row) => (
          <React.Fragment key={row}>
            {props.data.map((d, i) => {
              switch (d.type) {
                case 'random_text':
                  return (
                    <rect
                      x={d.x}
                      y={13 + 50 * row}
                      rx="5"
                      ry="5"
                      width={Math.random() * ((d.width || 300) - 100) + 100}
                      height="10"
                      key={`data_${row}_${i}`}
                    />
                  );
                case 'flag':
                  return (
                    <rect
                      x={d.x}
                      y={12 + 50 * row}
                      rx="5"
                      ry="5"
                      width={d.width}
                      height="20"
                      key={`data_${row}_${i}`}
                    />
                  );
                case 'circle':
                  return (
                    <circle
                      cx={d.x}
                      cy={22 + 50 * row}
                      r={d.radius}
                      key={`data_${row}_${i}`}
                    />
                  );
                case 'tdflag':
                  return (
                    <rect
                      x={d.x}
                      y={0 + 50 * row}
                      rx="0"
                      ry="0"
                      width="10"
                      height="40"
                      key={`data_${row}_${i}`}
                    />
                  );
                default:
                  return (
                    <rect
                      x={d.x}
                      y={13 + 50 * row}
                      rx="5"
                      ry="5"
                      width={d.width}
                      height="10"
                      key={`data_${row}_${i}`}
                    />
                  );
              }
            })}
          </React.Fragment>
        ))}
    </ContentLoader>
  );
};

const Loader = (props: { type?: string }) => {
  let loader;
  switch (props.type) {
    case 'spot_radio':
      loader = spotLoader;
      break;
    case 'solicitacao_chamada':
      loader = solicitacaoChamadaLoader;
      break;
    case 'chamada':
      loader = chamadaEditLoader;
      break;
    default:
      loader = solicitacaoPromoLoader;
      break;
  }
  return (
    <div style={{ padding: '2rem', height: '100%' }}>
      <Header data={loader} />
      <Table data={loader} />
    </div>
  );
};

export default Loader;
